import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import { BillToCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetBillTosApiParameter, BillToCollectionModel>;

export const PopulateApiParameterExtension: HandlerType = props => {
    const apiParameter = { ...props.parameter };
    apiParameter.expand = [];
    props.apiParameter = { ...apiParameter };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension)